import { Api_routes, server_url } from '@/config/API_Routes';
import { deleteRequest, postRequest } from '@/config/axios-config';

export const getAllConnectedBrands = (tokens) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllConnectedBrands,
        { tokens }
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export const addNewConnectedBrand = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.addNewConnectedBrand,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export const switchBrandAccount = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.switchBrandAccount,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export const removeConnectedBrand = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.removeConnectedBrand,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
